import { FC } from 'react';

interface Props {}

// The api_explorer_migration_enabled flag has been fully launched.
// This component is now a no-op and can be removed along with its references.
const ExplorerMigrationOptOut: FC<Props> = () => {
  return null;
};

export { ExplorerMigrationOptOut };
